import { handleActions, Reducer } from "redux-actions";
import {  
    ACTION_CHANGE_COLLAPSED,
} from "../actions/style";

export interface styleState {
    collapsed: boolean,
}

const defaultState: styleState = {
    collapsed: false,
}

function handleActionChangeCollapsedSuccess(state: styleState, action: any): styleState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        collapsed: action.payload.collapsed
    };
}


export const styleReducer: Reducer<styleState, any> = handleActions(
    {
        [ACTION_CHANGE_COLLAPSED]: handleActionChangeCollapsedSuccess,
    },
    defaultState
);
